import AssignmentIndOutlinedIcon from '@mui/icons-material/AssignmentIndOutlined';
import CenterFocusStrongIcon from '@mui/icons-material/CenterFocusStrong';
import ThumbsUpDownOutlinedIcon from '@mui/icons-material/ThumbsUpDownOutlined';
import { Box, IconButton, Stack, styled, Typography } from '@mui/material';
import { useNavigate } from 'react-router';
import { NewChip } from './new-chip';
import { SkillsSection } from './skills-section';
import { Carousel } from '@/components/shared/carousel';
import { InfoCard } from '@/components/shared/info-card';
import { UserAvatar } from '@/components/shared/user-avatar';
import { NewFeedbackCard } from '@/packages/home/components/user-profile/new-feedback-card';
import type { UserProfileData } from '@/packages/home/components/user-profile/use-user-profile-data';
import { lineClamp } from '@/utils/line-clamp';
import { profileGoalDescription } from '@/utils/profile-goal-description';

const INFO_MISSING_MESSAGE = 'Não informado';

const StyledCarousel = styled(Carousel)(({ theme }) => ({
  '.embla__container': {
    justifyContent: 'space-between',
  },
  '.embla__slide': {
    flex: '0 0 33.3%',
  },
  [theme.breakpoints.down('xl')]: {
    '.embla__slide': {
      flex: '0 0 389px',
    },
  },
  [theme.breakpoints.down('sm')]: {
    '.embla__slide': {
      flex: '0 0 330px',
    },
  },
}));

export const DefaultProfileLayout = ({
  jobs,
  userFeedback,
  recommendationProfile,
  profile,
  isProfileLoading,
}: UserProfileData) => {
  const navigate = useNavigate();
  const hasFeedback = userFeedback?.content;
  const FeedbackCard = hasFeedback ? InfoCard : NewFeedbackCard;

  return (
    <Stack spacing={2}>
      <Box>
        <Stack direction="row" spacing={2} alignItems="center">
          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
            }}
          >
            <IconButton onClick={() => navigate('/meu-perfil')}>
              <UserAvatar
                name={profile?.name || ''}
                size={64}
                imageSource={profile?.avatar}
                loading={isProfileLoading}
              />
            </IconButton>
          </Box>
          <Box sx={{ flexGrow: 1 }}>
            <Typography variant="h1">Olá, {profile?.first_name}</Typography>
          </Box>
        </Stack>
      </Box>
      <StyledCarousel
        loop={false}
        slidesComponents={[
          <FeedbackCard
            icon={ThumbsUpDownOutlinedIcon}
            onClick={() => {
              navigate(
                `/gestao-de-habilidades${!hasFeedback ? '?novo-feedback=true' : ''}`
              );
            }}
          >
            <Stack direction="row" spacing={1} alignItems="center">
              <Typography variant="h3">Feedback</Typography>
              {!hasFeedback && <NewChip />}
            </Stack>
            {hasFeedback ? (
              <Typography sx={lineClamp(1)}>{userFeedback?.content}</Typography>
            ) : (
              <Typography mt={0.5}>
                Envie seu feedback e receba recomendações personalizadas
              </Typography>
            )}
          </FeedbackCard>,

          <InfoCard icon={AssignmentIndOutlinedIcon}>
            <Typography variant="h3">Cargo atual</Typography>
            <Typography sx={lineClamp(1)}>
              {jobs?.current?.name ||
                recommendationProfile?.current_job?.name ||
                INFO_MISSING_MESSAGE}
            </Typography>
          </InfoCard>,

          <InfoCard icon={CenterFocusStrongIcon}>
            <Typography variant="h3">Objetivo de desenvolvimento</Typography>
            <Typography sx={lineClamp(1)}>
              {recommendationProfile &&
                profileGoalDescription(recommendationProfile, jobs)}
            </Typography>
          </InfoCard>,
        ]}
      />
      <SkillsSection />
    </Stack>
  );
};
